import * as React from "react";
import setGlobalMessages from "sh-application/actions/setGlobalMessages";
import { action } from "satcheljs/lib/legacy";
import { GlobalMessageViewState } from "../store/schema/GlobalMessageViewState";
import { MessageBarType } from "@fluentui/react";

/**
 * Action to set the message to display in the global message bar. Setting to blank string will clear the message.
 * @param {AppViewState} AppViewState
 * @param {string} message
 * @param {string} actionButtonTitle - title of optional action button (if you include a button title, you must include a callback function)
 * @param {Function} actionButtonCallback - callback for optional action button
 * @param {boolean} autoDismiss - set to true to have the message bar auto dismiss
 * @param {boolean} isCenterAligned - set to true to have the message center aligned
 * @param {number} autoDismissDelay - length of time in milliseconds to wait before auto dismissing the message bar
 * @param {number} autoDismissAnimationTimeout - duration of the animation in milliseconds to wait before auto dismissing the message bar
 * @param {boolean} useNewMessageBar - set to true to use the new Fluent UI v2 MessageBar component
 * @param {React.ReactElement} icon - custom icon for the message bar
 */
export default action("setGlobalMessage")(
    function setGlobalMessage(viewState: GlobalMessageViewState,
        message: React.ReactNode = null,
        messageBarType: MessageBarType = MessageBarType.info,
        actionButtonTitle: string = null,
        actionButtonCallback: Function = null,
        autoDismiss: boolean = false,
        isCenterAligned: boolean = false,
        autoDismissDelay: number = null,
        autoDismissAnimationTimeout: number = null,
        useNewMessageBar: boolean = false,
        icon: React.ReactElement = null,
        secondaryMessage: React.ReactNode = null,
        actionButtonAriaLabel: string = null) {
            if (message) {
                setGlobalMessages(viewState,
                    [message],
                    messageBarType,
                    actionButtonTitle,
                    actionButtonCallback,
                    autoDismiss,
                    false /* isMultiline */,
                    isCenterAligned,
                    autoDismissDelay,
                    autoDismissAnimationTimeout,
                    useNewMessageBar,
                    icon,
                    secondaryMessage,
                    actionButtonAriaLabel);
            } else {
                // to clear the global message bar
                setGlobalMessages(viewState,
                    null,
                    messageBarType,
                    actionButtonTitle,
                    actionButtonCallback,
                    autoDismiss,
                    false /* isMultiline */,
                    isCenterAligned,
                    autoDismissDelay,
                    autoDismissAnimationTimeout,
                    useNewMessageBar,
                    icon,
                    secondaryMessage,
                    actionButtonAriaLabel);
            }
        });